// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const actionGroupClasses = {
  root: "qui-action-group__root",
} as const
